<template>
  <div class="popup" v-if="showGuestsModal">
    <div class="popup-body special-scroll special-scroll-dark">
      <h3 class="text-right">רשימת שחקנים</h3>
      <div class="row">
        <div class="col-3">
          <h4>שם</h4>
        </div>
        <div class="col-3">
          <h4>טלפון</h4>
        </div>
        <div class="col-3">
          <h4>תאריך</h4>
        </div>
        <div class="col-3">
          <h4>הצביע</h4>
        </div>
      </div>
      <div :key="'g-'+k" class="row" v-for="(g, k) in guests">
        <div class="col-3">
          <p>{{ g.name }}</p>
        </div>
        <div class="col-3">
          <a target="_blank" :href="'https://api.whatsapp.com/send?phone=972'+fixILPhone(g.tel)">{{ g.tel }}</a>
        </div>
        <div class="col-3">
          <p>{{ g.create_date }}</p>
        </div>
        <div class="col-3">
          <a v-if="g.voted" :title="g.voted" href="#">כן</a>
          <p v-else></p>
        </div>
      </div>
    </div>
    <div class="popup-footer">
      <hr>
      <div class="row">
        <div class="col-6 text-right">
          <button class="btn btn-success" @click="exportCsvPlayers">הורד קובץ</button>
          <a id="csvLink" style="display:none;" href="#"></a>
        </div>
        <div class="col-6 text-left">
          <button @click="close" class="btn btn-danger">סגור</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlayersModal",
  props: ['showGuestsModal', 'guests'],
  components: {},
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('closeGuestsModal');
    },
    fixILPhone(val) {
      if (typeof val !== "string") val = "";
      val.replaceAll("+", "").replaceAll(" ", "").replaceAll("-", "").replaceAll("972", "");
      if (val.charAt(0) === "0") val = val.substr(1);
      return val;
    },
    exportCsvPlayers: function () {
      let headers = ["שם", "טלפון", "תאריך", "הצבעה"];
      let rows = [headers];

      this.guests.forEach((g) => {
        let player = [g.name, g.tel, g.create_date, g.voted];
        rows.push(player);
      });

      let processRow = function (row) {
        let finalVal = '';
        for (let j = 0; j < row.length; j++) {
          let innerValue = typeof row[j] === "undefined" || row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          }
          let result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0)
            result = '"' + result + '"';
          if (j > 0)
            finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };
      let csvFile = String.fromCharCode(0xFEFF);
      for (let i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }
      let blob = new Blob([csvFile], {type: 'text/csv;charset=utf-8;'});
      let url = URL.createObjectURL(blob);
      let link = document.getElementById("csvLink");
      link.setAttribute("href", url);
      link.setAttribute("download", "quizy-results-players-" + this.id + ".csv");
      link.click();
    },
  }
}
</script>

<style scoped lang="scss">
.popup {

  .popup-body {
    direction: rtl;
    height: 75vh;
  }

  h3 {
    margin: 20px 0;
  }

  .disabled {
    pointer-events: none;
    opacity: .75;
  }

  @media (max-width: 768px) {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;

    .popup-body {
      height: calc(100% - 80px);
    }
  }

}
</style>
